import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class InvoicesAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getAllInvoiceTemplates(router){
    const url = `/api/invoices/templates`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getInvoiceTemplatesById(id, router) {
    const url = `/api/invoices/templates/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createInvoiceTemplate(params, router) {
    const url = `/api/invoices/templates`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateInvoiceTemplate(id, params, router) {
    const url = `/api/invoices/templates/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteInvoiceTemplate(id, router) {
    const url = `/api/invoices/templates/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  updateInvoiceTemplateLogo(id, params) {
    const url = `/api/invoices/templates/logo/${id}`;
    return this.CommonAPIService.newFileCall(url, params);
  }

  getAllInvoiceSettings(router){
    const url = `/api/invoices/settings`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getInvoiceSettingsById(id, router) {
    const url = `/api/invoices/settings/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getInvoiceSettingsForSchool(id, router) {
    const url = `/api/invoices/settings/school/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createInvoiceSetting(params, router) {
    const url = `/api/invoices/settings`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateInvoiceSetting(id, params, router) {
    const url = `/api/invoices/settings/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteInvoiceSetting(id, router) {
    const url = `/api/invoices/settings/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  getAllInvoiceContacts(router){
    const url = `/api/invoices/contacts`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getAllInvoiceContactsForSchool(schoolId, router){
    const url = `/api/invoices/contacts/school/${schoolId}`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getInvoiceContactsById(id, router) {
    const url = `/api/invoices/contacts/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createInvoiceContact(params, router) {
    const url = `/api/invoices/contacts`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateInvoiceContact(id, params, router) {
    const url = `/api/invoices/contacts/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteInvoiceContact(id, router) {
    const url = `/api/invoices/contacts/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  getAllInvoices(router){
    const url = `/api/invoices/`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getInvoicesForFlightSchool(schoolId, router){
    const url = `/api/invoices/school/${schoolId}`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getInvoicesById(id, router) {
    const url = `/api/invoices/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createInvoice(params, router) {
    const url = `/api/invoices/`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateInvoice(id, params, router) {
    const url = `/api/invoices/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteInvoice(id, router) {
    const url = `/api/invoices/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

}
export default InvoicesAPIService;
